export default {
  street_and_number: 'Straße und Hausnummer',
  postal_code: 'Postleitzahl',
  town: 'Ort',
  country: 'Land',
  select_country: 'Land auswählen',
  manual_mode_hint:
    'Einige Felder konnten nicht automatisch ausgefüllt werden. Bitte vervollständigen Sie diese manuell.',
  edit: 'Bearbeiten',
  revalidation_title: 'Adresse vervollständigen',
  revalidation_text:
    'Bitte geben Sie Ihre Adresse an, um Ihr Profil zu vervollständigen.',
  revalidation_cta: 'Adresse vervollständigen',
  org_revalidation_title: 'Organisationsadresse vervollständigen',
  org_revalidation_text:
    'Bitte geben Sie die Organisationsadresse an, um das Firmenprofil zu vervollständigen.',
  org_revalidation_cta: 'Adresse vervollständigen',
}
